import React from 'react'
import CustomDivider from './CustomDivider'

const BadgeCard = ({data}) => {
  return (
    <>
    <div className='relative transform transition-transform duration-300 group-hover:-translate-y-3 '>
    <div className='flex items-center bg-light-primary rounded-custom cursor-pointer h-[200px] sm:h-[240px] w-full justify-start mt-30  transition duration-400'>
      <div className='relative'>
      <img src={data.image} alt="badge-card" className='mb-7 object-contain w-[240px] sm:w-[280px]' />
          <p className='text-sm absolute bottom-4 left-12 pl-5 font-bold mt-1 mb-1'>
       {data.text}
      <CustomDivider/>
      </p>
      </div>
    </div>
    <div className='rounded-full bg-light-theme absolute bottom-2 right-2 h-[15px] w-[15px] z-10'></div>
    </div>
    </>
  )
}

export default BadgeCard
